export const honeycombDataPortuguese = {
  contentArray: [
    {
      ID: 1,
      tabTitle: 'Mudança de sistema',
      leftColumnTitle: 'Variáveis do sistema',
      scenarioParameters: {
        systemScale: 'Participação de mercado: ~40%',
        systemScaleSub:
          'Grande mudança para a reutilização em uma infraestrutura altamente compartilhada',
        infrastructure: 'Embalagem compartilhada',
        packaging: 'Embalagem compartilhada',
        returnRate:
          '95% (permitindo que a embalagem seja reutilizada cerca de 15 vezes)',
      },
      chartURL:
        'https://emf.thirdlight.com/file/24/DYu4HUqDY7F5cPyDYf74DEOZ9Hb/Scenario-1-Data-Vis.png',
      imageCaption:
        'Trecho final do transporte, desde a "classificação e limpeza" até o "abastecimento"',
      mapURL:
        'https://emf.thirdlight.com/file/24/K6LOnIrK6Tvhpj0K63dkKvtt3sG/Honeycomb-S1-map.jpg',
      vimeoURL:
        'https://player.vimeo.com/video/858925722?background=1&badge=0&autoplay=1&loop=1&autopause=0&player_id=0&app_id=58479',
    },
    {
      ID: 2,
      tabTitle: 'Ação colaborativa',
      leftColumnTitle: 'Variáveis do sistema',
      scenarioParameters: {
        systemScale: 'Participação de mercado: ~10%',
        systemScaleSub:
          'Possível por meio de grandes mudanças de volume para reutilização e algum compartilhamento de infraestrutura',
        infrastructure: 'Embalagem sob medida',
        packaging: 'Médio',
        returnRate:
          '90% (permitindo que a embalagem seja reutilizada cerca de 10 vezes)',
      },
      chartURL:
        'https://emf.thirdlight.com/file/24/Om5sTEKOmpAvdhwOmSpsOmPYGL6/Scenario-2-Data-Vis.png',
      imageCaption:
        "Trajeto final de transporte da 'triagem e limpeza' até o 'envase'",
      mapURL:
        'https://emf.thirdlight.com/file/24/gVKyImJgVEq7RHHgVp2CgzBQkX6/Honeycomb-S2-map.jpg',
      vimeoURL:
        'https://player.vimeo.com/video/858926532?background=1&badge=0&autoplay=1&loop=1&autopause=0&player_id=0&app_id=58479',
    },
    {
      ID: 3,
      tabTitle: 'Esforço fragmentado',
      leftColumnTitle: 'Variáveis do sistema',
      scenarioParameters: {
        systemScale: 'Participação de mercado: ~2%',
        systemScaleSub:
          'Devido aos baixos volumes e à infraestrutura fragmentada',
        infrastructure: 'Embalagem sob medida',
        packaging: 'Alta',
        returnRate:
          '80% (permitindo que a embalagem seja reutilizada cerca de 5 vezes)',
      },
      chartURL:
        'https://emf.thirdlight.com/file/24/fBFIqehfBD0ALZNfBtDIfRWdTD/Scenario-3-Data-Vis.png',
      mapURL:
        'https://emf.thirdlight.com/file/24/pN3kJWTpNghDycLpNO18phIngnK/Honeycomb-S3-map.jpg',
      imageCaption:
        'Trajeto final de transporte da "triagem e limpeza" até o "abastecimento"',
      vimeoURL:
        'https://player.vimeo.com/video/858926809?background=1&badge=0&autoplay=1&loop=1&autopause=0&player_id=0&app_id=58479',
    },
  ],
  visualisationButtons: [
    'Cenário visual',
    'Resultados da modelagem de cenários',
  ],
  mapURLs: [
    'https://emf.thirdlight.com/file/24/K6LOnIrK6Tvhpj0K63dkKvtt3sG/Honeycomb-S1-map.jpg',
    'https://emf.thirdlight.com/file/24/gVKyImJgVEq7RHHgVp2CgzBQkX6/Honeycomb-S2-map.jpg',
    'https://emf.thirdlight.com/file/24/pN3kJWTpNghDycLpNO18phIngnK/Honeycomb-S3-map.jpg',
  ],
};
